import React from 'react';
import { Grid } from 'semantic-ui-react';
import selectors from '@/themes/hooks/selectors';
import fetch from '@/themes/hooks/fetch';
import HomeCarousel from './HomeCarousel';

const HomePanelCarousel = ({ codes }) => {
  const { images, readStatus } = selectors.useImageFetcher({ codes });
  fetch.useFetchImages({ items: codes }, readStatus);
  return (
    <Grid.Column>
      <HomeCarousel images={images} time={13000} />
    </Grid.Column>
  );
};

export default HomePanelCarousel;
